(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["absen-home-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const ready = new WeakSet();
    const init = (root) => {
      if (ready.has(root)) return;
      ready.add(root);
      const slides = [...root.querySelectorAll('[data-ah2-slide]')];
      const dots = [...root.querySelectorAll('[data-ah2-dot]')];
      const pauseButton = root.querySelector('[data-ah2-pause]');
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const delay = Number(root.dataset.delay) || 6000;
      let current = 0;
      let timer;
      let remaining = delay;
      let startedAt;
      let progress;
      let pausedByUser = root.dataset.startPaused === 'true';
      let pausedByInteraction = false;
      let visible = false;
      const initialImage = slides[0]?.querySelector('.ah2-hero__media img');
      let mediaReady = !initialImage || initialImage.complete;
      const mobileCatalog = root.querySelector('[data-ah2-mobile-catalog]');
      const mobilePages = mobileCatalog?.querySelector('[data-ah2-mobile-pages]');
      const mobileDots = [...(mobileCatalog?.querySelectorAll('[data-ah2-mobile-dot]') || [])];
      const updateMobileDots = () => {
        if (!mobilePages || !mobilePages.clientWidth) return;
        const page = Math.round(Math.abs(mobilePages.scrollLeft) / mobilePages.clientWidth);
        mobileDots.forEach((dot, index) => {
          const active = index === page;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', String(active));
        });
      };
      mobilePages?.addEventListener('scroll', updateMobileDots, { passive: true });
      mobileDots.forEach((dot) => dot.addEventListener('click', () => {
        mobilePages.scrollTo({ left: (getComputedStyle(mobilePages).direction === 'rtl' ? -1 : 1) * Number(dot.dataset.ah2MobileDot) * mobilePages.clientWidth, behavior: motion.matches ? 'auto' : 'smooth' });
      }));
      const stop = () => {
        if (timer !== undefined) remaining = Math.max(0, remaining - (performance.now() - startedAt));
        window.clearTimeout(timer);
        timer = undefined;
        progress?.pause();
      };
      const syncVideos = () => slides.forEach((slide, index) => {
        const video = slide.querySelector('video');
        if (!video) return;
        if (index === current && !document.hidden && !motion.matches && !(slide.querySelector('.ah2-hero__media--mobile-still') && window.matchMedia('(max-width: 749px)').matches)) video.play().catch(() => {});
        else video.pause();
      });
      const show = (index) => {
        if (!slides.length) return;
        stop();
        remaining = delay;
        progress?.cancel();
        root.removeAttribute('data-ah2-running');
        current = (index + slides.length) % slides.length;
        const image = slides[current].querySelector('template[data-ah2-image]');
        if (image) image.replaceWith(image.content);
        slides.forEach((slide, slideIndex) => {
          const active = slideIndex === current;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          if ('inert' in slide) slide.inert = !active;
          else slide.querySelectorAll('a').forEach((link) => { link.tabIndex = active ? 0 : -1; });
        });
        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === current;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', String(active));
        });
        syncVideos();
      };
      const start = () => {
        stop();
        if (!mediaReady || slides.length < 2 || root.dataset.autoplay !== 'true' || pausedByUser || pausedByInteraction || motion.matches || document.hidden || !visible) return;
        const nextImage = slides[(current + 1) % slides.length].querySelector('template[data-ah2-image]');
        if (nextImage) nextImage.replaceWith(nextImage.content);
        root.setAttribute('data-ah2-running', '');
        progress?.cancel();
        progress = dots[current]?.querySelector('.ah2-hero__progress-fill')?.animate(
          [{ transform: `scaleX(${1 - remaining / delay})` }, { transform: 'scaleX(1)' }],
          { duration: remaining, fill: 'forwards', easing: 'linear' }
        );
        startedAt = performance.now();
        timer = window.setTimeout(() => { show(current + 1); start(); }, remaining);
      };
      const go = (index) => { show(index); start(); };
      const frame = root.querySelector('.ah2-hero__frame');
      let gesture;
      frame?.addEventListener('pointerdown', (event) => {
        if (!window.matchMedia('(max-width: 749px)').matches || event.target.closest('a, button, nav')) return;
        gesture = { id: event.pointerId, x: event.clientX, y: event.clientY, slide: slides[current] };
        frame.setPointerCapture(event.pointerId);
        stop();
      });
      frame?.addEventListener('pointermove', (event) => {
        if (!gesture || event.pointerId !== gesture.id) return;
        const dx = event.clientX - gesture.x;
        const dy = event.clientY - gesture.y;
        if (Math.abs(dy) > Math.abs(dx)) return;
        gesture.slide.style.transform = `translateX(${dx}px)`;
      });
      const finishSwipe = (event) => {
        if (!gesture || event.pointerId !== gesture.id) return;
        const dx = event.clientX - gesture.x;
        const dy = event.clientY - gesture.y;
        gesture.slide.style.removeProperty('transform');
        gesture = undefined;
        if (event.type !== 'pointercancel' && Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) go(current + (dx < 0 ? 1 : -1));
        else start();
      };
      frame?.addEventListener('pointerup', finishSwipe);
      frame?.addEventListener('pointercancel', finishSwipe);
      root.querySelector('[data-ah2-prev]')?.addEventListener('click', () => go(current - 1));
      root.querySelector('[data-ah2-next]')?.addEventListener('click', () => go(current + 1));
      dots.forEach((dot) => dot.addEventListener('click', () => go(Number(dot.dataset.ah2Dot))));
      pauseButton?.addEventListener('click', () => {
        pausedByUser = !pausedByUser;
        pauseButton.setAttribute('aria-pressed', String(pausedByUser));
        pauseButton.setAttribute('aria-label', pausedByUser ? pauseButton.dataset.resumeLabel : pauseButton.dataset.pauseLabel);
        pauseButton.querySelector('[data-pause-icon]').hidden = pausedByUser;
        pauseButton.querySelector('[data-play-icon]').hidden = !pausedByUser;
        start();
      });
      root.addEventListener('mouseenter', () => { if (!window.matchMedia('(hover: hover)').matches) return; pausedByInteraction = true; stop(); });
      root.addEventListener('mouseleave', () => { pausedByInteraction = false; start(); });
      root.addEventListener('focusin', (event) => { if (!event.target.matches(':focus-visible')) return; pausedByInteraction = true; stop(); });
      root.addEventListener('focusout', (event) => {
        if (root.contains(event.relatedTarget)) return;
        pausedByInteraction = false;
        start();
      });
      document.addEventListener('visibilitychange', () => { syncVideos(); start(); });
      motion.addEventListener?.('change', () => { syncVideos(); start(); });
      window.addEventListener('resize', syncVideos);
      root.addEventListener('shopify:block:select', (event) => {
        const index = slides.findIndex((slide) => slide.contains(event.target) || slide === event.target);
        if (index >= 0) go(index);
      });
      // Give the first image its full reading interval, even on a slow
      // connection. Manual navigation remains available while it downloads.
      if (!mediaReady) {
        const begin = () => { mediaReady = true; start(); };
        initialImage.addEventListener('load', begin, { once: true });
        initialImage.addEventListener('error', begin, { once: true });
      }
      new IntersectionObserver(([entry]) => { visible = entry.isIntersecting; start(); }, { threshold: .2 }).observe(root);
      show(0);
      start();
    };
    document.querySelectorAll('[data-ah2-hero]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll?.('[data-ah2-hero]').forEach(init));
  })();

  } catch(e) { console.error(e); }
})();
})();
